(function () {
  'use strict';

  /* @ngdoc object
   * @name fdpViolationReport
   * @description
   *
   */
  angular
    .module('fdpViolationReport', [
      'ui.router'
    ]);
}());
